import type { CaseSubjectLink } from '../types/api';

/**
 * Pick the best subject link for display, preferring the `applicant` role
 * over `business` or any other role.
 */
export function preferApplicantSubject(
    caseSubjects?: CaseSubjectLink[],
): CaseSubjectLink | undefined {
    return (
        caseSubjects?.find((cs) => cs.role === 'applicant') ?? caseSubjects?.[0]
    );
}

/** Convenience: applicant display name (falls back to first subject name). */
export function applicantName(caseSubjects?: CaseSubjectLink[]): string | undefined {
    return preferApplicantSubject(caseSubjects)?.subject?.fullName;
}
